<template>
    <div class="step-1">
        <div class="row">
            <div class="col-md-4" :class="{'mb-3': isMobile}">
                <div class="auth-item">
                    <p>{{ $t('auth.login') }}</p>
                    <a href="#" @click.prevent="goToLogin" class="btn btn-primary btn-shadow text-uppercase">
                        {{ $t('auth.login') }}
                    </a>
                </div>
            </div>
            <div class="col-md-4" :class="{'mb-3': isMobile}">
                <div class="auth-item">
                    <p>{{ $t('auth.registration') }}</p>
                    <a href="#" @click.prevent="goToRegistration" class="btn btn-primary btn-shadow text-uppercase">
                        {{ $t('auth.registration') }}
                    </a>
                </div>
            </div>
            <div class="col-md-4">
                <div class="auth-item">
                    <p>{{ $t('auth.guest') }}</p>
                    <a href="#" @click.prevent="nextStep" class="btn btn-primary btn-shadow text-uppercase">
                        {{ $t('order_as_guest') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../scss/variables";

    .step-1 {
        display: flex;
        min-height: 100%;
        flex-grow: 1;
        flex-direction: column;
        justify-content: center;
    }

    .auth-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 30px;
        color: inherit;
        text-decoration: none;
        background-color: var(--bg-color);

        &:hover {
            box-shadow: 0 5px 15px rgba(#000, .15);
        }

        p {
            margin-bottom: 25px;
            font-size: 1.5rem;
        }
    }

    body.-is-mobile {

        .auth-item {

            @media (max-width: $size-landscape-phones) {
                padding-top: 18px;
                padding-bottom: 18px;

                p {
                    margin-bottom: 8px;
                    font-size: 1rem;
                }

                .btn {
                    font-size: .78rem;
                }
            }
        }
    }
</style>

<script>
  import checkoutStep1 from 'src/mixins/checkoutStep1Component';

  export default {
    mixins: [checkoutStep1],
  };
</script>